import { formatPageTitle } from "./pageTitle.js";

export const MAIL_TABS = ["dashboard", "emails", "apps", "recipients", "suppressions"] as const;
export type MailTab = (typeof MAIL_TABS)[number];
export const MAIL_TAB_LABELS: Record<MailTab, string> = {
  dashboard: "Dashboard",
  emails: "Recent emails",
  apps: "Per-app stats",
  recipients: "Recipients",
  suppressions: "Suppressions",
};
export const DEFAULT_MAIL_TAB: MailTab = "dashboard";

/** "/mail", "/mail/" -> default; "/mail/<known>[/]" -> it; "/mail/<unknown>" -> default; else null. */
export function mailTabFromPath(pathname: string): MailTab | null {
  const m = /^\/mail(?:\/([^/]*))?\/?$/.exec(pathname);
  if (!m) return null;
  const id = m[1];
  if (id && (MAIL_TABS as readonly string[]).includes(id)) return id as MailTab;
  return DEFAULT_MAIL_TAB;
}

export function mailTabPath(tab: MailTab): string {
  return tab === DEFAULT_MAIL_TAB ? "/mail" : `/mail/${tab}`;
}

export function mailTabTitle(tab: MailTab): string {
  return formatPageTitle(MAIL_TAB_LABELS[tab], "Mail");
}
